---
en:
  contract:
    active: Active
    counterpart: Counterpart
    end_date: Contract end date
    errors:
      ownership_unscaled_on_shadow: Feed-in-tariff and hedging contracts cannot be attached to a shadow power plant, which has no ownership share to split shared production.
    open_ended: Open-ended contract
    power_plant: Power plant
    power_plants: Power plants
    start_date: Contract start date
    type: Contract type
